export default {
  redirect_url: process.env.OAUTH2_REDIRECT_URL
};
